import { render, staticRenderFns } from "./widgetMarquee.vue?vue&type=template&id=5ecbd800&scoped=true&"
import script from "./widgetMarquee.vue?vue&type=script&lang=js&"
export * from "./widgetMarquee.vue?vue&type=script&lang=js&"
import style0 from "./widgetMarquee.vue?vue&type=style&index=0&id=5ecbd800&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecbd800",
  null
  
)

export default component.exports